import { createAsyncThunk } from '@reduxjs/toolkit';
import StatusMapAPI from './statusMapApi';

export const fetchStatusMapItemsThunk = createAsyncThunk(
  'statusMap/fetchItems',
  async (params, { rejectWithValue }) => {
    try {
      return await StatusMapAPI.fetchItems(params);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.error?.message || err?.response?.data?.detail || err.message || 'Failed to load status map items');
    }
  }
);

export const fetchStatusMapComponentsThunk = createAsyncThunk(
  'statusMap/fetchComponents',
  async (_, { rejectWithValue }) => {
    try {
      return await StatusMapAPI.fetchComponents();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.error?.message || err?.response?.data?.detail || err.message || 'Failed to load components');
    }
  }
);

export const createStatusMapItemThunk = createAsyncThunk(
  'statusMap/createItem',
  async (itemData, { rejectWithValue }) => {
    try {
      return await StatusMapAPI.createItem(itemData);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.error?.message || err?.response?.data?.detail || err.message || 'Failed to create item');
    }
  }
);

export const updateStatusMapItemThunk = createAsyncThunk(
  'statusMap/updateItem',
  async ({ itemId, updates }, { rejectWithValue }) => {
    try {
      return await StatusMapAPI.updateItem(itemId, updates);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.error?.message || err?.response?.data?.detail || err.message || 'Failed to update item');
    }
  }
);

export const deleteStatusMapItemThunk = createAsyncThunk(
  'statusMap/deleteItem',
  async (itemId, { rejectWithValue }) => {
    try {
      return await StatusMapAPI.deleteItem(itemId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.error?.message || err?.response?.data?.detail || err.message || 'Failed to delete item');
    }
  }
);
